export default __webpack_public_path__ + "static/media/FacebookSearch.c9c3bc38.png";